import { observer } from 'owa-mobx-react';
import { HotkeysMap } from 'owa-hotkeys-map';
import type { FunctionComponent } from 'react';

// deprecated in full-options in popout.
// this code should be removed when clean up acct-fullOptionsProjectionPopout flight
export const MailHotkeysMap: FunctionComponent<{}> = observer(function MailHotkeysMap() {
    return <HotkeysMap />;
}, 'MailHotkeysMap');
